var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { class: _vm.myClass + " price-fmt", style: _vm.mysty },
    [
      _vm.hasUnit
        ? _c("i", { style: _vm.unitStyle }, [
            _vm._v(_vm._s(_vm.isMinus && "-") + "￥"),
          ])
        : _vm._e(),
      _c("span", { staticClass: "interge", style: _vm.smallInterge }, [
        _vm._v(_vm._s(_vm.intergePrice)),
      ]),
      _vm._v("."),
      _c("span", { staticClass: "decimal", style: _vm.smallDecimal }, [
        _vm._v(_vm._s(_vm.decimalPrice)),
      ]),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm._t("text"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }